export const parsePersoneller = (value) => {
    if (!value || value === "null") return [];

    if (Array.isArray(value)) {
        return value.map(personel => String(personel).trim()).filter(Boolean);
    }

    try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
            return parsed.map(personel => String(personel).trim()).filter(Boolean);
        }
    } catch (error) {
        // JSON olmayan eski kayıtlar virgüllü metin olarak ayrıştırılır.
    }

    return String(value)
        .split(/\s*,\s*/)
        .map(personel => personel.trim())
        .filter(Boolean);
};

export const getTekilPersoneller = (rows) => {
    const personeller = new Set();

    rows.forEach(row => {
        parsePersoneller(row.teknik_personeller).forEach(personel => {
            personeller.add(personel);
        });
    });

    return Array.from(personeller).sort((a, b) => a.localeCompare(b, 'tr'));
};

/** @param {unknown[]} rows sayfa satırları (fallback)
 *  @param {string[]|null} namesOverride serverside: lookup / facet listesi */
export const personelFilterOptions = (rows, namesOverride = null) => ({
    fullWidth: true,
    names: Array.isArray(namesOverride) && namesOverride.length
        ? namesOverride
        : getTekilPersoneller(rows || []),
    logic(value, filters) {
        if (filters.length === 0) return false;

        const rowPersoneller = parsePersoneller(value);
        return !filters.every(personel => rowPersoneller.includes(personel));
    },
});

export const personelFilterListOptions = {
    render: value => `Personel: ${value}`,
};
